import { type SearchTopBar } from "~/components/Components/SearchTopBar/SearchTopBar";
import { type TitleTopBar } from "~/components/Components/TitleTopBar/TitleTopBar";
import { TopBar } from "~/components/Components/TopBar/TopBar";

type Props = {
  isSearchMode: boolean;
  titleTopBarProps: React.ComponentProps<typeof TitleTopBar>;
  searchTopBarProps: React.ComponentProps<typeof SearchTopBar>;
};

export const FandomHeaderModule = (props: Props) => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    <TopBar
      barType={props.isSearchMode ? "search" : "title"}
      topBarProps={
        props.isSearchMode ? props.searchTopBarProps : props.titleTopBarProps
      }
    />
  );
};
